$(document).ready(function () {

  const params = new URLSearchParams(window.location.search);
  const qtyFromUrl = parseInt(params.get("qty"));
  if (!qtyFromUrl || qtyFromUrl <= 0) return;

  // =============================
  // Get base price
  // =============================
  function getPriceNumber() {
    // Get sale price if exists
    let $sale = $('.price-item.price-item--sale.price-item--last');
    if ($sale.length && $sale.text().trim() !== '') {
      let salePrice = parseFloat($sale.text().replace('CHF', '').replace(',', '.').trim());
      return isNaN(salePrice) ? 0 : salePrice;
    }

    // Otherwise get regular price
    let $regular = $('.price-item.price-item--regular').first();
    if ($regular.length) {
      let regularPrice = parseFloat($regular.text().replace('CHF', '').replace(',', '.').trim());
      return isNaN(regularPrice) ? 0 : regularPrice;
    }

    return 0;
  }

  // =============================
  // Update price based on qty
  // =============================
  function updatePrice(qty) {
    const priceNumber = getPriceNumber();
    const total = priceNumber * qty;

    // Update directly in DOM
    let formatted = 'CHF ' + total.toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    // Update regular price
    let $regular = $('.price-item.price-item--regular').first();
    if ($regular.length) $regular.text(formatted);

    // Update sale price if exists
    let $sale = $('.price-item.price-item--sale.price-item--last');
    if ($sale.length) $sale.text(formatted);
  }

  // =============================
  // Apply qty & update price
  // =============================
  function applyQty() {
    const $input = $('.quantity__input');
    if ($input.length > 0) {
      $input.val(qtyFromUrl);
      $input.trigger('change');

      const $minus = $('.quantity__button[name="minus"]');
      if (qtyFromUrl > 1) $minus.removeClass('disabled');

      updatePrice(qtyFromUrl);
    }
  }

  // =============================
  // PHASE 1 — on page load
  // =============================
  const firstObserver = new MutationObserver(() => {
    if ($('.quantity__input').length) {
      applyQty();
      firstObserver.disconnect();
    }
  });
  firstObserver.observe(document.body, { childList: true, subtree: true });

  // =============================
  // PHASE 2 — when any variant option changes
  // =============================
  $('body').on('change', 'variant-selects input[type="radio"]', function () {
    setTimeout(() => {
      const variantObserver = new MutationObserver(() => {
        if ($('.quantity__input').length) {
          applyQty();
          variantObserver.disconnect();
        }
      });
      variantObserver.observe(document.body, { childList: true, subtree: true });
    }, 50);
  });

});
